import {
  Component,
  OnInit,
  ViewEncapsulation,
  ViewChild,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Dictionary } from "src/app/store/models/common_types";
import {
  SetDpParams,
  DeleteDpParams,
  SetAuditCallFbar,
} from "src/app/store/actions/global-subheader.actions";
import { GlobalSubheaderDataService } from "../global-subheader-data.service";
import {
  chevronLeft,
  chevronRight,
  VAIconRegistryService,
  caretRight,
  doubleArrowRight,
  fileExcel,
  infoCircle,
  guidance,
} from "@va/core-library/icons";
import {
  NzFormatEmitEvent,
  NzTreeNode,
  NzTreeComponent,
} from "ng-zorro-antd/tree";
import { AppService } from "src/app/app.service";
import {
  AuditCallBool,
  FormulaBarData,
} from "src/app/store/models/global-subheader.model";
import { SafeResourceUrl, DomSanitizer } from "@angular/platform-browser";
import { CompanyDataService } from "../../company-page/company-data.service";
import { HttpClient } from "@angular/common/http";
import { ActivatedRoute, ActivatedRouteSnapshot } from "@angular/router";
import { NzMessageService } from "ng-zorro-antd/message";
import { Subscription } from "rxjs";

@Component({
  selector: "app-subheader-formulabar",
  templateUrl: "./subheader-formulabar.component.html",
  styleUrls: ["./subheader-formulabar.component.scss"],
  host: {
    class: "formulabar-component",
    "(document:keydown)": "isEscKeyPressed($event)",
  },
  encapsulation: ViewEncapsulation.None,
})
export class SubheaderFormulabarComponent implements OnInit, OnDestroy {
  dpParams: Dictionary<any>;
  apiEP: string = window.apiUrl;
  formulabarData: Dictionary<any> = {};
  expandFormulabar = false;
  nodes: {
    extra: Dictionary<any>;
    isLeaf: boolean;
    isRoot: boolean;
    isChild: boolean;
    operator?: string;
    brokerValues?: any;
    mappingLinks?: Dictionary<any>;
    key?: string;
  }[];
  fbarExpanded = false;
  operators: string[] = ["-", "*", "/"];
  growthParams: string[] = [
    "YoY%",
    "YoY#",
    "yoy%",
    "yoy#",
    "seq%",
    "seq#",
    "Seq%",
    "Seq#",
  ];
  brokerCountForSellSide = -1;
  includedPages: Array<string> = ["comps"];
  legacyUrl = `${window.caUrl}/app`;
  statusError = false;
  errorMessage = "";
  defaultExpandedKeys = ["expandFbar"];
  auditCall = false;
  original_cut = null;
  original_revision = null;
  @Input() comparativeAnalysisBorderedFormulaBar?: boolean = false;
  @Input() comparativeAnalysisShortFormulaBar?: boolean = false;
  @Output() newFbarEvent: EventEmitter<boolean> = new EventEmitter();
  @ViewChild("nzTreeComponent")
  nzTreeComponent: NzTreeComponent;
  //@ViewChild("filingFrame", {static: false}) filingFrame: ElementRef;
  opdVals = [];
  opdDpIds = new Set();
  oprs = new Set<string>();
  ticker = "";
  cut = "";
  source = "";
  actionSource = "";
  extras: any = "";
  fbarActionLogged = false;
  expressionList = [];
  expressionOperands = [];
  sarWithOperand = false;
  clickedcellID: any = "";
  loading = false;
  fiscalSources = [
    "consensus",
    "consensus+",
    "custom consensus",
    "custom",
    "va actuals",
  ];
  viewModalSrc: SafeResourceUrl;
  isViewModalVisible = false;
  filingsError = false;
  isInferred = false;
  domIdToScroll = "";
  historicalRevision = "";
  dpParamSource = "";
  inclSources = [];
  exclSources = [];
  customParam = "";
  customPeriod = "";
  filingsHeading: string;
  documentType: string;
  datePublish: string;
  documentId: number;
  guidanceCount = 0;
  hasGuidance: boolean;
  currentGuidance = 0;
  guidanceList;
  showFx = true;
  disableAnchorLink = false; // disable anchor tags and stop opening new tab if any
  // Excel Addin Fields - start
  openedForAddIn = false;
  addInDpURL = "";
  // Excel Addin Fields - end
  routeSnapshot: ActivatedRouteSnapshot;
  isFirstClick = true;
  dpParamsSubscription: Subscription;
  file_type: any = "";
  fbarDpCallSubscription: Subscription;
  valuationCuts = [
    "VLR",
    "CSCALCR",
    "SCALCR",
    "SVAAR",
    "ADJ",
    "NTM",
    "STM",
    "LTM",
    "NTMU",
    "STMU",
    "CAR",
    "CCAR",
    "OTFCALAISD",
  ];
  isUniversalsliid = false;
  pdf_data_iframe_src = "";
  targetPriceDp = [
    "REF_13",
    "REF_13_86",
    "REF_13_87",
    "REF_13_83",
    "REF_13_85",
  ];
  showNewFbar: boolean = false;
  isDpCallObjReady: boolean = false;
  dpCallObj;

  constructor(
    private store: Store<AppState>,
    private appService: AppService,
    private dataService: GlobalSubheaderDataService,
    private companyService: CompanyDataService,
    private http: HttpClient,
    private iconRegistryService: VAIconRegistryService,
    private route: ActivatedRoute,
    private message: NzMessageService,
    private sanitizer: DomSanitizer,
  ) {
    this.iconRegistryService.registerIcons([
      chevronLeft,
      chevronRight,
      fileExcel,
      doubleArrowRight,
      caretRight,
      infoCircle,
      guidance,
    ]);
  }

  ngOnDestroy() {
    this.hasGuidance = false;
    if (this.dpParamsSubscription) {
      this.dpParamsSubscription.unsubscribe();
      this.dpParamsSubscription = null;
    }
    if (this.fbarDpCallSubscription) {
      this.fbarDpCallSubscription.unsubscribe();
    }
    this.store.dispatch(new DeleteDpParams());
    window.removeEventListener("summonFBar", this.summonFbarFunction);
    window.removeEventListener("openFBar", this.openFbarFunction);
  }

  ngOnInit() {
    this.routeSnapshot = this.route.snapshot;
    this.openedForAddIn = this.routeSnapshot.queryParams.addin === "true";
    if (this.openedForAddIn) {
      this.showFx = false;
      this.disableAnchorLink = true;
      this.addInDpURL = this.getAddInDPParams(this.routeSnapshot.queryParams);
    }
    //This event is triggered from the mex grid on data cell clicks
    window.addEventListener("SummonFBar", this.summonFbarFunction.bind(this));

    //This event is triggered from the "Audit Formula" option of the context menu
    window.addEventListener("openFBar", this.openFbarFunction.bind(this));

    this.dpParamsSubscription = this.store
      .select(stateGetter("globalSubheader", "dpParams"))
      .subscribe((data: Dictionary<any>) => {
        this.showNewFbar =
          window.location.pathname.split("/")[1] === "mex" ||
          window.location.pathname.split("/")[3] === "nav";
        this.newFbarEvent.emit(this.showNewFbar);
        this.resetData();

        //If new dpParams object is recevied, cancel the previously invoked dp call and stop loader.
        if (this.fbarDpCallSubscription) {
          this.fbarDpCallSubscription.unsubscribe();
          this.loading = false;
        }

        if (this.showNewFbar && (data.dp || this.openedForAddIn)) {
          this.setDpCallObject({ ...data });
          return;
        }

        if (data.dp || this.openedForAddIn) {
          this.loading = true;
          this.historicalRevision = data.historical_revision;
          let rootUrl = "";
          if (this.openedForAddIn) {
            rootUrl = `/api/dp?${this.addInDpURL}`;
          } else {
            rootUrl = this.getRootUrl(data);
            if (data.source.toLowerCase() === "custom") {
              this.dpParamSource = data.source.toLowerCase();
              this.inclSources = data.incl_sources;
              this.exclSources = data.excl_sources;
              this.customParam = data.param;
              this.customPeriod = data.period;
            }
            this.isUniversalsliid = data.isUniversalsliid;
          }

          this.fbarDpCallSubscription = this.dataService
            .fbarDP(rootUrl)
            .subscribe(
              (res) => {
                if (res) {
                  this.formulabarData = res;
                  if (
                    res.status !== "error" &&
                    Object.keys(this.formulabarData).length > 1
                  ) {
                    this.setDetailsRequiredForLog(res);
                    this.addRootNode();
                  } else {
                    this.statusError = true;
                    this.errorMessage = res.message || "0.00";
                  }
                  this.loading = false;
                  if (this.openedForAddIn) {
                    setTimeout(() => {
                      this.store.dispatch(
                        new SetAuditCallFbar({ expanded: true }),
                      );
                    }, 0);
                  }
                }
              },
              (/*error*/) => {
                //no response
                // console.log(error);
                this.loading = false;
              },
            );
        }
      });

    this.store
      .select(stateGetter("globalSubheader", "isAuditCall"))
      .subscribe((isAuditCall: AuditCallBool) => {
        if (isAuditCall.expanded) this.expandAuditFormula();
      });

    if (!this.openedForAddIn) {
      this.store.dispatch(new DeleteDpParams());
    }
  }

  setDpCallObject(data) {
    let dpCallObj = new FormulaBarData();
    const dataJson = { ...data };
    // let  field = "";
    //set newfbar details and return
    if (window.location.pathname.split("/")[1] === "mex") {
      //mex page specific -  refactor this later

      const field = data.cellElement.field;
      const period = data.period.toLowerCase();
      const source = decodeURIComponent(data.source.toLowerCase());
      let revision = field;
      if (field.includes(period)) {
        revision = revision.slice(period.length);
      }
      if (field.includes(source)) {
        revision = revision.slice(0, revision.length - source.length);
      }
      revision = data.cellElement.revision || revision;
      revision = revision === "Current" ? revision : revision.toLowerCase();
      this.original_revision = revision;

      const extras =
        data.cut.toLowerCase() !== "sar"
          ? `${data.dp.split("|")[0]}|${period}${revision}${source}`
          : `${data.dp.split("|")[0]}|${period}${revision}`;
      dataJson.extras = extras;
      dataJson.source = source === "consensusplus" ? "Consensus+" : source;
      if (revision === "consensusplus") {
        dataJson.historical_revision = "";
      } else {
        dataJson.historical_revision = revision;
      }
    }
    dpCallObj = FormulaBarData.fromJson(dataJson);
    this.dpCallObj = dpCallObj.toDTO();
    this.isDpCallObjReady = true;
    this.setDetailsRequiredForLog({
      ticker: dpCallObj.ticker,
      cut: dpCallObj.cut,
      source: dpCallObj.source,
      dp: dpCallObj.dp,
    });
  }

  openFbarFunction() {
    this.store.dispatch(new SetAuditCallFbar({ expanded: true }));
  }
  summonFbarFunction(dataObj: any) {
    if (
      this.clickedcellID &&
      this.clickedcellID !== "" &&
      this.clickedcellID !== null &&
      this.clickedcellID.classList
    ) {
      this.clickedcellID.classList.remove("tdbgcolor", "tdbgborder");
    }

    //handling for empty cell click
    if (!dataObj.detail.data.dp) {
      this.resetData();
      return;
    }

    // adding bg-color  to clicked cell
    let selector = `[id='${dataObj.detail.data.dp}']`;
    if (document.querySelectorAll(selector).length > 1) {
      const sourceName = dataObj.detail.data.source.replace("+", "plus");
      selector = `${selector}[field$='${sourceName}' i]`;
    }

    // fix for 2 datapoints highlighted if have same id
    // ESTC_US/NMV/RV -> Total revenue - Total subscription
    // this.clickedcellID = document.querySelector(selector);
    // const clickedSelector = `[id='${dataObj.detail.data.cellElement.id}']`;
    this.clickedcellID = dataObj.detail.data.cellElement;
    if (
      this.clickedcellID &&
      this.clickedcellID !== "" &&
      this.clickedcellID !== null &&
      this.clickedcellID.classList
    ) {
      this.clickedcellID.classList.add("tdbgcolor", "tdbgborder");
    }

    // Handle the source encoding in a common place
    dataObj.detail.data.source = encodeURIComponent(dataObj.detail.data.source);
    dataObj.detail.data.historical_focus = encodeURIComponent(
      dataObj.detail.data.historical_focus,
    );

    this.loading = true;
    // const detailData = {...dataObj.detail.data};
    const cellData = {
      id: (this.clickedcellID && this.clickedcellID.getAttribute("id")) || null,
      field:
        (this.clickedcellID && this.clickedcellID.getAttribute("field")) ||
        null,
      dapparam_id:
        (this.clickedcellID &&
          this.clickedcellID.getAttribute("dapparam_id")) ||
        null,
      revision:
        (this.clickedcellID && this.clickedcellID.getAttribute("revision")) ||
        null,
    };
    dataObj.detail.data.cellElement = cellData;
    const detailData = this.appService.deepClone(dataObj.detail.data);
    this.store.dispatch(new SetDpParams(detailData));
  }
  handleCancel() {
    this.isViewModalVisible = false;
  }

  addRootNode() {
    this.nodes = [this.getRootObject()];
  }

  // To set up header template based on operator
  getRootObject() {
    if (this.formulabarData.formula) {
      if (this.formulabarData.formula.opr) {
        this.expressionList = [];
        this.expressionOperands = [];
        this.generateExpression(this.formulabarData.formula);
        return {
          extra: this.formulabarData,
          brokerValues: this.getOpdValues(
            this.formulabarData.formula.opd,
            this.formulabarData.name,
          ),
          operator: this.formulabarData.formula.opr.toUpperCase(),
          isLeaf: false,
          isRoot: true,
          isChild: false,
          title: " ",
          generatedExpression: this.expressionList,
          key: "expandFbar",
          brokerCountForSellSide: this.brokerCountForSellSide,
        };
      }
      return {
        extra: this.formulabarData,
        brokerValues: [
          {
            value: this.formulabarData.value,
            precision: this.formulabarData.precision,
            cut: this.formulabarData.cut,
            unit: this.formulabarData.unit,
            brokerCount: -1,
            name: this.formulabarData.formula.name,
            period: this.formulabarData.formula.period,
            source: this.formulabarData.formula.source,
            formatedValue: Number(this.formulabarData.value).toFixed(2),
          },
        ],
        isLeaf: false,
        isRoot: true,
        isChild: false,
        title: " ",
        key: "expandFbar",
        brokerCountForSellSide: this.brokerCountForSellSide,
      };
    }
    if (this.formulabarData.nmv_link) {
      this.setMappingLinks();
    }
    return {
      extra: this.formulabarData,
      isLeaf: false,
      isRoot: true,
      isChild: false,
      title: " ",
      key: "expandFbar",
      name: this.formulabarData.name,
    };
  }

  // Line mapping for SAR
  setMappingLinks() {
    const linksObjs = this.formulabarData.nmv_link.links;
    const capComMapping = Object.values(linksObjs[0]);
    const linkMapping: any = { CAP: [], COM: [] };
    const capIds = capComMapping[0]["CAP"];
    const linksObj = linksObjs[1];

    for (const id in linksObj) {
      const tabs = linksObj[id].tabs;
      const name = linksObj[id].name;
      const dpId = linksObj[id].nmv_dp_id;

      for (let i = 0; i < tabs.length; i++) {
        if (capIds.includes(Number(id))) {
          linkMapping["CAP"].push({
            name: name,
            tabSName: tabs[i][0],
            tabName: tabs[i][1],
            dpid: dpId,
          });
        } else {
          linkMapping["COM"].push({
            name: name,
            tabSName: tabs[i][0],
            tabName: tabs[i][1],
            dpid: dpId,
          });
        }
      }
    }
    this.formulabarData["linkMapping"] = linkMapping;
  }

  getOpdValues(values, dpName?, opr?) {
    let brokerValues: Array<any> = [];
    values = this.filterIfSellSideUser(values, dpName);

    if (
      (opr && opr === "avg") ||
      (!opr &&
        (this.formulabarData.formula.opr === "/" ||
          this.formulabarData.formula.opr === "*" ||
          this.formulabarData.formula.opr === "avg" ||
          this.formulabarData.formula.opr === "-"))
    ) {
      for (const val of values) {
        if (val.opd) {
          this.opdVals = [];
          this.opdDpIds.clear();
          this.recursiveOpdValues(val);
          val.opd = this.opdVals ? this.opdVals : val.opd;
          const vals = val.opd.map((value) => ({
            value: value.value,
            precision: value.precision,
            cut: value.cut,
            unit: value.unit,
            brokerCount: this.brokerCountForSellSide,
            exchange_info: value.exchange_info,
            isConst: value.type === "CONST",
            name: value.name,
            period: value.period,
            source: value.source,
            annotation: val.annotation,
            formatedValue: Number(value.value).toFixed(2),
          }));
          brokerValues = brokerValues.concat(vals);
          return brokerValues;
        }
        const opdV = [...values];
        const vals = opdV
          .filter((v) => {
            // The second condition checks whether it is target price datapoint
            return (
              v.type !== "CONST" ||
              ((this.formulabarData.formula.opr === "avg" || opr === "avg") &&
                typeof v.value === "number" &&
                v.type === "CONST" &&
                v.cut === "REF")
            );
          })
          .map((value) => ({
            value: value.value,
            precision: value.precision,
            cut: value.cut,
            unit: value.unit,
            brokerCount: this.brokerCountForSellSide,
            exchange_info: value.exchange_info,
            isConst: value.type === "CONST",
            name: value.name,
            period: value.period,
            source: value.source,
            annotation: value.annotation,
            formatedValue: Number(value.value).toFixed(2),
          }));
        brokerValues = brokerValues.concat(vals);
        return brokerValues;
      }
    } else {
      return values.map((value) => ({
        value: value.value,
        precision: value.precision,
        cut: value.cut,
        unit: value.unit,
        exchange_info: value.exchange_info,
        isConst: value.type === "CONST",
        name: value.name,
        period: value.period,
        source: value.source,
        brokerCount: this.brokerCountForSellSide,
        annotation: value.annotation,
        formatedValue: Number(value.value).toFixed(2),
      }));
    }
    return values;
  }

  // filter 'not entitled' param ids from opdValues if user is not entitled
  // @todo : ideally in such case 'not entitled' params shouldn't be returned from backend
  filterIfSellSideUser(values, dpName?) {
    // if root node along with currency
    const isCurrencyNodeThere = values.length > 1 && values[1].type === "CONST";

    // isCurrencyNodeThere isn't satisfying the condition when 0th node is not entitled and 1st node has data, so handling this for target price data point
    const hasNotEntitledValue =
      dpName &&
      dpName.toLowerCase() === "target price" &&
      values.filter((item) => item.param_id === "not entitled").length > 0;

    const vals =
      isCurrencyNodeThere && !hasNotEntitledValue
        ? this.getSubFormulaValue(values[0])
        : values;

    if (!Array.isArray(vals)) return values;
    let filteredValues = vals.filter(
      (item) => item.param_id !== "not entitled",
    );
    const notEntitledValues = vals.filter(
      (item) => item.param_id === "not entitled",
    );
    this.brokerCountForSellSide =
      notEntitledValues.length > 0
        ? notEntitledValues.length
        : this.brokerCountForSellSide;
    // set filtered values back to original formula
    if (isCurrencyNodeThere && !hasNotEntitledValue) {
      values[0].formula.opd = filteredValues;
      filteredValues = values;
    } else {
      this.formulabarData.formula.opd = filteredValues;
    }
    return filteredValues;
  }

  // triggered when expand icon is clicked
  onFbarExpand(event: Required<NzFormatEmitEvent>): void {
    //Add onFbarClick logic to this function for  node expansion
    if (event.node && event.node.origin.extra.expand_disabled) {
      return;
    }
    // Hack to get around ANT's bug
    if (event.node.level === 0 && this.isFirstClick === true) {
      event.node.isExpanded = !event.node.isExpanded;
      this.isFirstClick = false;
    }
    this.addChildNode(event.node);
    this.showHideStatsSection(event.node);
  }

  // triggered when 'clicked' on expression
  onFbarClick(event: Required<NzFormatEmitEvent>): void {
    if (event.node && event.node.origin.extra.expand_disabled) {
      return;
    }
    // Hack to get around ANT's bug
    if (event.node.level === 0 && this.isFirstClick === true) {
      event.node.isExpanded = !event.node.isExpanded;
      this.isFirstClick = false;
    }
    if (event.node.isExpanded) {
      event.node.isExpanded = false;
      const extra = event.node.origin.extra;
      if (extra && extra.cut === "SAR") {
        this.logFbarAction(
          {},
          this.ticker,
          extra.cut,
          "DATAPOINT_COLLAPSE",
          extra.source,
          null,
          `${extra.source}|${extra.dp}`,
        );
      } else if (!event.node.origin.isRoot && !event.node.origin.isLeaf) {
        this.logFbarAction(
          {},
          this.ticker,
          extra.cut,
          "SOURCE_LEVEL_FORMULA_COLLAPSE",
          extra.source,
          null,
          `${extra.source}|${extra.dp}`,
        );
      }
    } else {
      event.node.isExpanded = true;
      this.addChildNode(event.node);
    }
    this.showHideStatsSection(event.node);
  }

  showHideStatsSection(clickedNode) {
    if (clickedNode.origin.isRoot && this.fbarExpanded) {
      this.fbarExpanded = false;
      clickedNode.isExpanded = false;
      this.logFbarAction(
        {},
        this.ticker,
        this.formulabarData.cut,
        "FORMULA_BAR_CLOSED",
        this.formulabarData.source,
        this.actionSource,
      );
    } else if (clickedNode.origin.isRoot) {
      this.fbarExpanded = true;
    }
  }

  // create new child node on expand of parent node
  addChildNode(node) {
    this.resetChildLevelData();
    if (
      node &&
      node.getChildren().length === 0 &&
      node.isExpanded &&
      !node.isLeaf
    ) {
      const extra = node.origin.extra;
      this.isInferred =
        (extra.annotation && extra.annotation.charAt(0) > 0) ||
        node.origin.isInferred === true;
      if (extra && extra.restricted && extra.cut !== "SAR") {
        const params = this.getChildUrl(extra, node.parentNode);
        this.dataService.fbarDP(params).subscribe(
          (res) => {
            if (res) {
              // reset broker count before creating new child node...why ?
              //this.resetBrokerCount();
              this.setDetailsRequiredForLog(res);
              if (res.source !== "Filings" && res.formula && res.formula.opd) {
                res.formula.opd = this.recursiveOpdValues(res.formula);
                for (const vals of res.formula.opd) {
                  if (
                    vals.cut === "REF" || //used for handling a EV/EBITDA case on valuation page
                    (vals.type !== "CONST" &&
                      vals.param_id &&
                      vals.param_id !== "not entitled")
                  ) {
                    vals["fromOpd"] = true;
                    this.sarWithOperand =
                      res.formula.opr &&
                      vals.cut !== undefined &&
                      vals.cut.toLowerCase() === "sar"
                        ? true
                        : this.sarWithOperand;
                    node.addChildren(this.filterChildValues(vals));
                  }
                }
              } else {
                node.addChildren(this.filterChildValues(res));
              }
              this.logFbarAction(
                {},
                this.ticker,
                this.cut,
                "SOURCE_LEVEL_FORMULA_EXPANSION",
                this.source,
                this.actionSource,
                this.extras,
              );
              this.nodes;
            }
          },
          (/*error*/) => {
            //no response
            // console.log(error);
          },
        );
      } else if (extra && extra.formula) {
        if (
          extra.formula.opd &&
          (!extra.growthtype ||
            extra.growthtype === "Analytics" ||
            extra.growthtype.includes("#"))
        ) {
          // used for logging purpose
          this.extras = [];
          const extraVals = this.recursiveOpdValues(extra.formula);
          for (const vals of extraVals) {
            //if (vals.type !== "CONST") { YoY and revisioj value with single source
            // the third if condition checks whether it is target price datapoint
            if (
              (vals.param_id && vals.param_id !== "not entitled") ||
              (!vals.param_id &&
                vals.type === "CONST" &&
                vals.name !== "CONST") ||
              (!vals.param_id &&
                vals.cut === "REF" &&
                this.targetPriceDp.includes(vals.dp))
            ) {
              this.isInferred =
                ((vals.annotation && vals.annotation.charAt(0) > 0) ||
                  node.origin.isInferred === true) &&
                vals.annotation &&
                vals.annotation.charAt(0) > 0 &&
                this.isInferred;
              vals["fromOpd"] = true;
              this.sarWithOperand =
                extra.formula.opr &&
                vals.cut !== undefined &&
                vals.cut.toLowerCase() === "sar"
                  ? true
                  : this.sarWithOperand;
              node.addChildren(this.filterChildValues(vals));
              this.setExtraListForLog(vals);
            }
            //}
          }
        } else {
          node.addChildren(this.filterChildValues(extra));
        }
        if (this.openedForAddIn) {
          this.extras = { ...this.extras, addinClientType: "addinweb" };
        }
        this.logFbarAction(
          {},
          this.ticker,
          this.cut,
          "FORMULA_BAR_EXPANDED",
          this.source,
          this.actionSource,
          this.extras,
        );
        this.fbarActionLogged = true;
      } else {
        if (extra && extra.cut === "SAR") {
          this.getModelDetails(node, extra);
        } else {
          const params = this.getChildUrl(extra, node.parentNode);
          this.fbarDpCallSubscription = this.dataService
            .fbarDP(params)
            .subscribe(
              (res) => {
                if (res) {
                  this.setDetailsRequiredForLog(res);
                  if (Object.keys(res).length > 1) {
                    node.addChildren(this.filterChildValues(res));
                  }
                  this.logFbarAction(
                    {},
                    this.ticker,
                    this.cut,
                    "SOURCE_LEVEL_FORMULA_EXPANSION",
                    this.source,
                    this.actionSource,
                    this.extras,
                  );
                }
              },
              (/*error*/) => {
                //no response
                // console.log(error);
              },
            );
        }
      }
    }

    if (!this.fbarExpanded && !this.fbarActionLogged) {
      if (this.openedForAddIn) {
        this.extras = { ...this.extras, addinClientType: "addinweb" };
      }
      this.logFbarAction(
        {},
        this.ticker,
        this.cut,
        "FORMULA_BAR_EXPANDED",
        this.source,
        this.actionSource,
        this.extras,
      );
    }
  }

  // create and return DP call url for child nodes
  getChildUrl(node, parentNode = null) {
    const pg = node.parameter_group ? node.parameter_group : "";
    const revisionDate = node.revision_date ? node.revision_date : "";
    const dp = revisionDate !== "" ? `${node.dp}|${revisionDate}` : node.dp;
    const shouldLogvalue = node.cut.toLowerCase() === "nmv" ? true : false;
    let dpUrl = `/api/dp?dp=${dp}&original_cut=${this.original_cut}&cut=${
      node.cut
    }&source=${encodeURIComponent(
      node.source,
    )}&pg=${this.appService.fixedEncodeURIComponent(
      pg,
    )}&shouldLog=${shouldLogvalue}&ticker=${node.ticker}`;
    if (parentNode && parentNode.origin && parentNode.origin.extra) {
      dpUrl += `&parent_dp=${parentNode.origin.extra.dp}`;
    }
    if (this.isUniversalsliid) {
      dpUrl += `&is_universalsliid=true`;
    }
    //test this once
    if (node.source.toLowerCase() === "custom") {
      if (node.refdate) {
        dpUrl = `${dpUrl}&logic_based_consensus=true&earnings=${node.earnings}&refdate=${node.refdate}`;
      } else {
        if (node.incl_sources) {
          dpUrl = `${dpUrl}&incl_sources=${node.incl_sources}`;
        }
        if (node.excl_sources) {
          dpUrl = `${dpUrl}&excl_sources=${node.excl_sources}`;
        }
      }
      if (this.dpParamSource === "custom") {
        if (this.inclSources) {
          dpUrl = `${dpUrl}&incl_sources=${this.inclSources}`;
        }
        if (this.exclSources) {
          dpUrl = `${dpUrl}&excl_sources=${this.exclSources}`;
        }
        if (this.customParam && node.cut.toLowerCase() !== "sch") {
          dpUrl = `${dpUrl}&param=${this.customParam}`;
        }
        if (this.customPeriod) {
          dpUrl = `${dpUrl}&period=${this.customPeriod}`;
        }
      }
    }

    if (node.cut.toLowerCase() === "sch") {
      dpUrl += `&param=${node.param_id}`;
    }

    if (
      node.fiscalperiod &&
      node.cut &&
      this.valuationCuts.includes(node.cut)
    ) {
      dpUrl += `&period=${node.fiscalperiod}`;
    }

    if (this.original_revision) {
      let revision = this.original_revision;
      if (revision === "PreQ|PreQ") {
        revision = revision.split("|")[0].toLowerCase();
      }
      dpUrl += `&extras=${
        node.dp
      }|${node.fiscalperiod.toLowerCase()}${revision}${node.source}`;
    }

    if (this.openedForAddIn) {
      if (
        this.routeSnapshot &&
        this.routeSnapshot.queryParams &&
        this.routeSnapshot.queryParams.tickertype
      ) {
        dpUrl = `${dpUrl}&tickertype=${this.routeSnapshot.queryParams.tickertype}`;
      }
    }

    return dpUrl;
  }

  filterChildValues(values) {
    let childNodes: Array<any> = [];
    this.expressionList = [];
    this.expressionOperands = [];

    // if no expression available
    if (values.expresssion_error) {
      childNodes.push({
        extra: values,
        isLeaf: true,
        title: " ",
        key: values.expr,
      });
      return childNodes;
    }

    if (values.formula && values.formula.opd) {
      // for second level operator which we show in comps
      if (
        values.growthtype &&
        (values.growthtype.toLowerCase().includes("yoy") ||
          values.growthtype.toLowerCase().includes("seq") ||
          values.growthtype.toLowerCase().includes("change") ||
          values.growthtype.toLowerCase().includes("trend"))
      ) {
        // this block get's executed when growthtype is other than 'Analytics'
        values = this.filterIfSellSideUser(values.formula.opd, values.name);
        for (const obj of values) {
          this.expressionList = [];
          this.expressionOperands = [];
          if (obj.formula && obj.formula.opd !== undefined) {
            const opdVals = obj.formula.opd;
            const opr = obj.formula.opr;

            if (obj.expresssion_error) {
              childNodes.push({
                extra: obj,
                isLeaf: true,
                title: " ",
                key: values.expr,
              });
              continue;
            }

            /* in case of yoy%, growth same object we are getting two times
              1 in opd of outer formula object and 2nd time in opd of inner formula object
              so ignoring outer one and setting up values while traversing the inner object because it's exactly same
            */

            if (
              !(opr === "/" || opr === "+" || opr === "*") &&
              !this.valuationCuts.includes(obj.cut)
            ) {
              childNodes.push({
                extra: obj,
                isChild: true,
                operator: opr.toUpperCase(),
                brokerValues: this.getOpdValues(opdVals, obj.name),
                popOverText: this.getPopOverText(obj),
                title: " ", //this.getPopOverText(obj),
                key: values.expr,
                brokerCountForSellSide: this.brokerCountForSellSide,
              });
            }
          } else if (obj.opd) {
            for (const opdV of obj.opd) {
              this.expressionList = [];
              this.expressionOperands = [];
              if (opdV.formula && opdV.formula.opd !== undefined) {
                const opdVals = opdV.formula.opd;
                const opdFormula = opdV.formula;
                const opr = opdV.formula.opr;
                const brokerValues = this.getOpdValues(opdVals, opdV.name, opr);
                if (
                  brokerValues.length === 0 &&
                  opdVals.length === this.brokerCountForSellSide
                ) {
                  childNodes.push({
                    extra: opdV,
                    isLeaf: true,
                    operator: opr.toUpperCase(),
                    brokerValues: brokerValues,
                    title: " ",
                    key: values.expr,
                  });
                } else {
                  this.generateExpression(opdFormula);
                  childNodes.push({
                    extra: opdV,
                    isChild: true,
                    operator: opr.toUpperCase(),
                    brokerValues: brokerValues,
                    generatedExpression: this.expressionList,
                    popOverText: this.getPopOverText(opdV),
                    title: " ", // this.getPopOverText(opdV),
                    key: values.expr,
                  });
                }
              } else {
                // for SAR yoy calculation
                this.generateExpression(opdV);
                childNodes.push({
                  extra: opdV,
                  isChild:
                    opdV.exchange_info && opdV.cut === "REF" ? false : true,
                  isLeaf:
                    opdV.exchange_info && opdV.cut === "REF" ? true : false,
                  generatedExpression: this.expressionList,
                  popOverText: this.getPopOverText(opdV),
                  brokerCountForSellSide: this.brokerCountForSellSide,
                  title: " ", // this.getPopOverText(opdV),
                  key: values.expr,
                });
              }
            }
          } else if (obj.exchange_info) {
            // in case if objetc includes currency related information -> show exchange info as leaf node
            childNodes.push({
              extra: obj,
              isLeaf: true,
              title: " ",
              key: values.expr,
            });
          } else {
            // figure out better approach
            if (this.formulabarData.cut !== "SAR" && values.formula) {
              this.generateExpression(values.formula);
              childNodes.push({
                extra: values.formula,
                isChild: true,
                generatedExpression: this.expressionList,
                popOverText: this.getPopOverText(values.formula),
                brokerCountForSellSide: this.brokerCountForSellSide,
                title: " ", // this.getPopOverText(values.formula),
                key: values.expr,
              });
              return childNodes;
            }
          }
        }
        return childNodes;
      }
      if (values.formula.opr) {
        this.generateExpression(values.formula);
        childNodes.push({
          extra: values,
          brokerValues: this.getOpdValues(
            values.formula.opd,
            values.name,
            values.formula.opr,
          ),
          operator: values.formula.opr.toUpperCase(),
          isChild: true,
          generatedExpression: this.expressionList,
          popOverText: this.getPopOverText(values),
          isInferred: this.isInferred,
          brokerCountForSellSide: this.brokerCountForSellSide,
          title: " ", // this.getPopOverText(values),
          key: values.expr,
        });
      } else {
        values = this.filterIfSellSideUser(values.formula.opd, values.name);
        this.generateExpression(values);
        // check this
        childNodes = childNodes.concat(
          values.map((val) => ({
            extra: val,
            isChild: true,
            generatedExpression: this.expressionList,
            popOverText: this.getPopOverText(val),
            brokerCountForSellSide: this.brokerCountForSellSide,
          })),
        );
      }
      return childNodes;
    }
    if (values.formula && values.cut !== "SAR") {
      const childFormula = values.formula;
      if (childFormula.expresssion_error) {
        childNodes.push({
          extra: childFormula,
          isLeaf: true,
          title: " ",
          key: values.expr,
        });
      } else if (childFormula.formula && childFormula.formula.opr) {
        this.generateExpression(childFormula.formula);
        childNodes.push({
          extra: childFormula,
          operator: childFormula.formula.opr.toUpperCase(),
          brokerValues: this.getOpdValues(
            childFormula.formula.opd,
            childFormula.name,
          ),
          isChild: true,
          generatedExpression: this.expressionList,
          popOverText: this.getPopOverText(childFormula),
          isInferred: this.isInferred,
          brokerCountForSellSide: this.brokerCountForSellSide,
          title: " ", // this.getPopOverText(childFormula),
          key: childFormula.expr,
        });
      } else {
        // removed values.fromOpd flag which was used to determine from which next level should be constructed to avoid cyclic expansion
        // this block get's executed when cut for 'next' formula is 'SAR'
        values = values.fromOpd
          ? delete values.fromOpd && values
          : values.formula;
        this.generateExpression(values);
        childNodes.push({
          extra: values,
          isChild: true,
          generatedExpression: this.expressionList,
          popOverText: this.getPopOverText(values),
          isInferred: this.isInferred,
          brokerCountForSellSide: this.brokerCountForSellSide,
          title: " ", // this.getPopOverText(values),
          key: values.expr,
        });
      }
    } else {
      // this block get's executed when cut for current formula is 'SAR'
      if (this.sarWithOperand) {
        childNodes.push({
          extra: values,
          isChild: true,
          popOverText: this.getPopOverText(values),
          brokerCountForSellSide: this.brokerCountForSellSide,
          title: " ", // this.getPopOverText(values),
          key: values.expr,
        });
      } else {
        childNodes.push({
          extra: values,
          isLeaf: true,
          title: " ", // this.getPopOverText(values),
          key: values.expr,
        });
      }
    }
    return childNodes;
  }

  // get model details and create child node based on the API response
  getModelDetails(node, extra) {
    const params = `/api/modeldetail?dp=${extra.dp}&cut=${extra.cut}&source=${extra.source}&company=${extra.ticker}&pg=&documentid=${extra.documentid}`;
    if (!node.isLeaf) {
      this.dataService.getFbarModelDetails(params).subscribe(
        (res) => {
          if (res.status === "success") {
            extra["documentDate"] = res.docDate;
            extra["sheetName"] = res.sheet_name;
            extra["cellRef"] = res.cellId;
            extra["modelDetailDocumentId"] = res.documentId;
            this.file_type = res.file_type;
            this.documentType = res.document_type ? res.document_type : "";
            node.addChildren(this.filterChildValues(extra));
          }
        },
        (/*error*/) => {
          //no response
          // console.log(error);
        },
      );
    }
  }
  downloadModelFromNewFb(event) {
    const node = {
      documentid: event.item.modelData.documentId,
      modelDetailDocumentId: event.item.modelData.documentId,
      source: event.item.source,
      pg: this.dpCallObj.pg,
      cellRef: event.item.modelData.cellId,
      ticker: this.dpCallObj.ticker,
      cut: this.dpCallObj.cut,
      fiscalperiod: this.dpCallObj.period,
      documentDate: event.item.modelData.docDate,
    };
    this.file_type = event.item.modelData.file_type;
    this.documentType = event.item.modelData.document_type;
    this.downloadModel(node);
  }

  downloadModel(node) {
    // @TODO check global method used in app.service.ts -> need different parameters
    // console.log(`Downloading document(${node.documentid}, ${node.source}).`);
    const downloadType =
      node.source && node.source.toLowerCase() === "filings"
        ? "filings"
        : "model";

    if (this.file_type === "xlsx" && downloadType === "filings") {
      this.message.error(
        "Error: This filings document is in excel format and cannot be viewed",
        {
          nzDuration: 5000,
        },
      );
      // skip further code in case of xlsx files for clientapp
      if (!this.openedForAddIn) {
        return;
      }
    }
    //uniqueid is giving isue in this
    const extraParams = {
      documentid: node.documentid,
      source: node.source,
      pg: node.pg ? node.pg : "",
      downloadType: downloadType,
      cellId: node.cellRef,
      ticker: node.ticker,
      cut: node.cut,
    };
    if (downloadType === "filings") {
      //Filings documents are loaded in a popup
      let filingsParams = {};
      if (this.openedForAddIn) {
        filingsParams = {
          //for filings we are passing the modeldetaildocumentID value to documnetId variable.
          documentId: node.modelDetailDocumentId,
          is_addin_call: true,
          ticker: this.routeSnapshot.queryParams.ticker,
          downloadType: downloadType,
          cut: this.routeSnapshot.queryParams.cut,
          pg: window.pg,
          cellId: node.cellRef,
        };
      } else {
        filingsParams = {
          //for filings we are passing the modeldetaildocumentID value to documnetId variable.
          documentId: node.modelDetailDocumentId,
          companyId:
            window.location.pathname.split("/")[1] === "mex"
              ? window.MEData.companyid
              : "",
          ticker: node.ticker,
          downloadType: downloadType,
          cut:
            window.location.pathname.split("/")[1] === "mex"
              ? window.cut
              : node.cut,
          pg: window.pg,
          cellId: node.cellRef,
        };
      }
      this.pdf_data_iframe_src = "";
      const filingsTitle =
        node.source === "Filings" ? "<b>Company Announcements" : "";
      this.filingsHeading = `${filingsTitle} |</b> ${node.fiscalperiod}`;
      // this.documentType = node.document_type;
      this.datePublish = node.documentDate;
      this.documentId = node.modelDetailDocumentId;
      this.currentGuidance = 0;
      this.guidanceCount = 0;
      this.companyService.getViewModelSrc(filingsParams).subscribe((msg) => {
        const param = {
          documentId: node.modelDetailDocumentId,
        };
        if (msg["fileType"] === "htm" || msg["fileType"] === "html") {
          this.domIdToScroll = msg.domId;
          this.isViewModalVisible = true;
          this.hasGuidance = msg.guidance;
          const options = {
            responseType: "text" as const,
          };

          if (msg.guidance) {
            this.companyService.getGuidanceData(param).subscribe(
              (response) => {
                const doc =
                  document.getElementById("filingsFrame")["contentWindow"]
                    .document;
                if (doc && response) {
                  doc.open();
                  doc.write(response);
                  doc.close();
                  this.onOpenFilingsDoc();
                  setTimeout(() => {
                    this.companyService
                      .getGuidanceList(param)
                      .subscribe((response) => {
                        this.guidanceList = response["data"].guidances;
                        this.guidanceCount = this.guidanceList.length;
                        const filingsDocClass = document
                          .getElementById("filingsFrame")
                          ["contentWindow"].document.getElementsByClassName(
                            "bkmk_filings_span_class",
                          );
                        for (let i = 0; i < filingsDocClass.length; i++) {
                          filingsDocClass[i].style.backgroundColor = "#FFEFCB";
                        }
                      });
                  }, 1000);
                }
              },
              (error) => {
                console.error(error);
              },
            );
          } else {
            this.http.get(msg.url, options).subscribe(
              (htmlData) => {
                const doc =
                  document.getElementById("filingsFrame")["contentWindow"]
                    .document;
                if (doc && htmlData) {
                  doc.open();
                  doc.write(htmlData);
                  doc.close();
                  this.onOpenFilingsDoc();
                }
              },
              (error) => {
                console.error(error);
              },
            );
          }
          // this.http.get(msg.url, options).subscribe(
          //   (htmlData) => {
          //     const doc = document.getElementById("filingsFrame")[
          //       "contentWindow"
          //     ].document;
          //     doc.open();
          //     doc.write(htmlData);
          //     doc.close();
          //     this.onOpenFilingsDoc();
          //   },
          //   (error) => {
          //     console.error(error);
          //   }
          // );
          // this.viewModalSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
          //   msg.url
          // );
        }

        //         if (msg["fileType"] === "pdf") {
        //           this.isViewModalVisible = true;
        //           this.filingsError = false;
        //           setTimeout(() => {
        //             this.pdf_data_iframe_src = 'data:application/pdf;base64, '+msg["pdf_value"];
        //             document.getElementById("filingsFrame").setAttribute("src",this.pdf_data_iframe_src);
        //           },100);
        //         }

        if (msg["fileType"] === "pdf") {
          this.isViewModalVisible = true;
          this.filingsError = false;
          const options = {
            responseType: "arraybuffer",
          };
          filingsParams = {
            documentId: node.modelDetailDocumentId,
            cellId: node.cellRef,
          };
          this.companyService.getPDFFilings(filingsParams, options).subscribe(
            (pdfData) => {
              if (pdfData["status"] === "error") {
                console.error(pdfData["message"]);
              } else {
                const file = new Blob([pdfData], { type: "application/pdf" });
                const fileURL = URL.createObjectURL(file);
                document
                  .getElementById("filingsFrame")
                  .setAttribute("src", fileURL);
              }
            },
            (error) => {
              console.error(error);
            },
          );
        }

        if (msg.status === "error") {
          this.filingsError = true;
          this.isViewModalVisible = true;
        } else {
          this.filingsError = false;
        }

        if (msg.force_logout) {
          window.location.href = `${this.legacyUrl}/homepage/?force_logout=true`;
        }

        this.appService.logUserAction(
          {},
          this.ticker,
          window.cut,
          this.hasGuidance
            ? "FILINGS_WITH_GUIDANCE"
            : "FILINGS_WITHOUT_GUIDANCE",
          {
            documentId: this.documentId,
          },
          node.source,
          null,
        );
      });
    } else {
      this.appService.excelDownload("model_download", extraParams);
    }
  }
  onNextGuidance() {
    if (this.currentGuidance < this.guidanceCount) {
      this.currentGuidance += 1;
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;
      const filingsDoc = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementById(guidanceId);
      filingsDoc.scrollIntoView();
      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }

      this.appService.logUserAction(
        {},
        this.ticker,
        "HOME",
        "GUIDANCE_NAVIGATION_CLICK",
        {
          documentId: this.documentId,
        },
        "",
        null,
      );
    }
  }
  onPrevGuidance() {
    if (this.currentGuidance > 1) {
      this.currentGuidance -= 1;
      const guidanceId =
        this.guidanceList[this.currentGuidance - 1].start_tag_id;
      const filingsDoc = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementById(guidanceId);
      filingsDoc.scrollIntoView();
      const currFilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(`bkmk_${guidanceId}`);
      const allfilingsDocClass = document
        .getElementById("filingsFrame")
        ["contentWindow"].document.getElementsByClassName(
          "bkmk_filings_span_class",
        );
      for (let i = 0; i < allfilingsDocClass.length; i++) {
        allfilingsDocClass[i].style.backgroundColor = "#FFEFCB";
      }
      for (let i = 0; i < currFilingsDocClass.length; i++) {
        currFilingsDocClass[i].style.backgroundColor = "#FFC846";
      }

      this.appService.logUserAction(
        {},
        this.ticker,
        "HOME",
        "GUIDANCE_NAVIGATION_CLICK",
        {
          documentId: this.documentId,
        },
        "",
        null,
      );
    }
  }
  getPdfSrc() {
    if (this.pdf_data_iframe_src) {
      return this.sanitizer.bypassSecurityTrustResourceUrl(
        this.pdf_data_iframe_src,
      );
    }

    return null;
  }

  //On load, we need to scroll to the cell id, if specified in the model call
  onOpenFilingsDoc() {
    if (this.domIdToScroll !== "") {
      setTimeout(() => {
        const filingsDoc = document
          .getElementById("filingsFrame")
          ["contentWindow"].document.getElementById(this.domIdToScroll);
        filingsDoc.style.backgroundColor = "#FFE48D";
        filingsDoc.scrollIntoView();
      }, 1000);
    }
  }

  getAddInDPParams(queryParams): string {
    let url = "";
    if (queryParams.growthType) {
      url = `${url}&growthType=${encodeURIComponent(queryParams.growthType)}`;
    }
    if (queryParams.currency) {
      url = `${url}&currency=${queryParams.currency}`;
    }
    if (queryParams.depth) {
      url = `${url}&depth=${queryParams.depth}`;
    }
    if (queryParams.period) {
      url = `${url}&period=${queryParams.period}`;
    }
    if (queryParams.ticker) {
      url = `${url}&ticker=${queryParams.ticker}`;
    }
    if (queryParams.revision) {
      url = `${url}&revision=${queryParams.revision}`;
    }
    if (queryParams.tickertype) {
      url = `${url}&tickertype=${queryParams.tickertype}`;
    }
    return `source=${queryParams.source}&paramid=${queryParams.paramid}&original_cut=${queryParams.cut}&cut=${queryParams.cut}&extras=${queryParams.extras}${url}`;
  }

  // create and return DP call url for root node
  getRootUrl(dpParams) {
    this.original_cut = dpParams.cut;
    let dpUrl = `/api/dp?dp=${dpParams.dp}&original_cut=${this.original_cut}&cut=${dpParams.cut}&source=${dpParams.source}&ticker=${dpParams.ticker}&shouldLog=${dpParams.shouldLog}`;
    if (dpParams.pg && dpParams.pg !== "") {
      dpUrl += `&pg=${this.appService.fixedEncodeURIComponent(dpParams.pg)}`;
    }
    if (dpParams.revision && dpParams.revision !== "") {
      dpUrl += `&revision=${dpParams.revision}`;
    }
    if (dpParams.currency && dpParams.cut === "STD") {
      dpUrl += `&currency=${dpParams.currency}`;
    }
    if (dpParams.currency && dpParams.cut === "NMV") {
      dpUrl += `&currency=${dpParams.currency}`;
    }
    if (dpParams.historical_focus && dpParams.historical_focus !== "") {
      dpUrl += `&historical_focus=${dpParams.historical_focus}`;
    }
    if (dpParams.enable_fuzzy && dpParams.enable_fuzzy !== "") {
      dpUrl += `&enable_fuzzy=${dpParams.enable_fuzzy}`;
    }
    if (dpParams.param && dpParams.param !== "") {
      if (dpParams.cut.toLowerCase() !== "sch") {
        dpUrl += `&param=${dpParams.param}`;
      } else {
        dpUrl += `&schlineid=${dpParams.param}`;
      }
    }
    if (dpParams.period && dpParams.period !== "") {
      dpUrl += `&period=${dpParams.period}`;
    }
    if (dpParams.period_type) {
      dpUrl += `&period_type=${dpParams.period_type}`;
    }
    if (dpParams.tpr_page) {
      dpUrl += `&tpr_page=${dpParams.tpr_page}`;
    }
    if (dpParams.partial_entitled_sid) {
      dpUrl += `&partial_entitled_sid=${dpParams.partial_entitled_sid}`;
    }
    if (dpParams.is_comparative_rev) {
      dpUrl += `&is_comparative_rev=${dpParams.is_comparative_rev}`;
    }
    if (
      dpParams.source.toLowerCase() === "custom" &&
      dpParams.logic_based_consensus === undefined
    ) {
      let sourcePanelObj: any = {};
      if (window.MEData !== undefined) {
        sourcePanelObj = window.MEData.panels.filter(function (data) {
          return data.name.toLowerCase() === "sources";
        })[0];
      }
      const inclExtraSources = [];
      const exclExtraSources = [];
      // Only append for broker based cc
      if (
        sourcePanelObj.sources_in_progress_excluded.length > 0 &&
        sourcePanelObj.selected_excl_cc_not_entitled === true
      ) {
        for (
          let i = 0;
          i < sourcePanelObj.sources_in_progress_excluded.length;
          i++
        ) {
          if (
            inclExtraSources.indexOf(
              sourcePanelObj.sources_in_progress_excluded[i],
            ) === -1
          ) {
            inclExtraSources.push(
              sourcePanelObj.sources_in_progress_excluded[i],
            );
          }
        }
      } else if (
        sourcePanelObj.sources_in_progress_excluded.length > 0 &&
        sourcePanelObj.selected_excl_cc_not_entitled === false
      ) {
        for (
          let i = 0;
          i < sourcePanelObj.sources_in_progress_excluded.length;
          i++
        ) {
          if (
            exclExtraSources.indexOf(
              sourcePanelObj.sources_in_progress_excluded[i],
            ) === -1
          ) {
            exclExtraSources.push(
              sourcePanelObj.sources_in_progress_excluded[i],
            );
          }
        }
      }
      if (
        sourcePanelObj.sources_in_progress_included.length > 0 &&
        sourcePanelObj.selected_cc_not_entitled === true
      ) {
        for (
          let i = 0;
          i < sourcePanelObj.sources_in_progress_included.length;
          i++
        ) {
          if (
            inclExtraSources.indexOf(
              sourcePanelObj.sources_in_progress_included[i],
            ) === -1
          ) {
            inclExtraSources.push(
              sourcePanelObj.sources_in_progress_included[i],
            );
          }
        }
      } else if (
        sourcePanelObj.sources_in_progress_included.length > 0 &&
        sourcePanelObj.selected_cc_not_entitled === false
      ) {
        for (
          let i = 0;
          i < sourcePanelObj.sources_in_progress_included.length;
          i++
        ) {
          if (
            exclExtraSources.indexOf(
              sourcePanelObj.sources_in_progress_included[i],
            ) === -1
          ) {
            exclExtraSources.push(
              sourcePanelObj.sources_in_progress_included[i],
            );
          }
        }
      }

      if (dpParams.incl_sources) {
        const incSourcesVal =
          inclExtraSources.length > 0 ? `,${inclExtraSources}` : "";
        dpUrl += `&incl_sources=${dpParams.incl_sources}${incSourcesVal}`;
      }
      if (dpParams.excl_sources) {
        const exclSourcesVal =
          exclExtraSources.length > 0 ? `,${exclExtraSources}` : "";
        dpUrl += `&excl_sources=${dpParams.excl_sources}${exclSourcesVal}`;
      }
      if (dpParams.excl_reaffirm_broker_consensus) {
        dpUrl += `&excl_reaffirm_broker_consensus=${dpParams.excl_reaffirm_broker_consensus}`;
      }
    }
    if (dpParams.isUniversalsliid) {
      dpUrl += `&is_universalsliid=true`;
    }
    let growthType = encodeURIComponent(dpParams.growthType)
      ? dpParams.growthType
      : "";
    growthType = this.growthParams.includes(dpParams.growthType)
      ? encodeURIComponent(growthType)
      : growthType;
    if (growthType !== "") dpUrl += `&growthType=${growthType}`;
    if (dpParams.logic_based_consensus !== undefined) {
      dpUrl += `&logic_based_consensus=${dpParams.logic_based_consensus}&refdate=${dpParams.refdate}&earnings=${dpParams.earnings}`;
    }
    if (window.location.pathname.split("/")[1] === "mex") {
      //mex page specific -  refactor this later
      const field = dpParams.cellElement.field;
      const period = dpParams.period.toLowerCase();
      const source = dpParams.source.toLowerCase();
      let revision = field;
      if (field.includes(period)) {
        revision = revision.slice(period.length);
      }
      if (field.includes(source)) {
        revision = revision.slice(0, revision.length - source.length);
      }
      revision = dpParams.cellElement.revision || revision;
      revision = revision.toLowerCase();
      this.original_revision = revision;
      dpUrl +=
        dpParams.cut.toLowerCase() !== "sar"
          ? `&extras=${dpParams.dp.split("|")[0]}|${period}${revision}${source}`
          : `&extras=${dpParams.dp.split("|")[0]}|${period}${revision}`;
    } else {
      //In comps there is no key as period, but extras are sent as is
      this.original_revision = dpParams.revision;
      dpUrl += `&extras=${dpParams.extras}`;
    }
    return dpUrl;
  }

  loadViewinNewTab(event, linkObj) {
    //Adding this for a bug which collapses the row after redirect
    event.stopPropagation();
    if (this.disableAnchorLink) {
      return;
    }
    const dp = encodeURIComponent(`${linkObj.dp}|${linkObj.revision_date}`);
    const url = `${window.location.protocol}//${window.location.host}/mex/${
      linkObj.ticker
    }/${linkObj.cut}/${this.appService.fixedEncodeURIComponent(
      linkObj.parameter_group,
    )}/${linkObj.source}?expand_consensus=true&dpid=${dp}&period=${
      this.formulabarData.fiscalperiod
    }`;
    window.open(url, "_blank");
  }

  // reset data on every new cell click before making DP call
  resetData() {
    this.formulabarData = {};
    this.expandFormulabar = false;
    this.nodes = [];
    this.fbarExpanded = false;
    this.brokerCountForSellSide = -1;
    this.statusError = false;
    this.auditCall = false;
    this.opdVals = [];
    this.opdDpIds.clear();
    this.sarWithOperand = false;
    this.historicalRevision = "";
    this.dpParamSource = "";
    this.inclSources = [];
    this.exclSources = [];
    this.customParam = "";
    this.customPeriod = "";
    this.isFirstClick = true;
    this.isDpCallObjReady = false;
    this.dpCallObj = new FormulaBarData();
  }

  // close fbar if exc key is pressed
  isEscKeyPressed(event: KeyboardEvent) {
    let isEscape = false;
    isEscape =
      "key" in event ? event.key === "Escape" || event.key === "Esc" : isEscape;
    // isEscape = (event.which == 27);
    if (isEscape && this.fbarExpanded) {
      const node: NzTreeNode =
        this.nzTreeComponent.getTreeNodeByKey("expandFbar");
      node.isExpanded = false;
      this.fbarExpanded = false;
      this.logFbarAction(
        {},
        this.ticker,
        this.formulabarData.cut,
        "FORMULA_BAR_CLOSED",
        this.formulabarData.source,
        "KEYBOARD_SHORTCUT",
      );
    }
  }

  // expand formulabar on expandAuditFormula select from context menu
  expandAuditFormula() {
    if (this.showNewFbar) {
      const formulabar: HTMLElement = document.querySelector(
        ".formula-bar .mat-tree-node",
      );
      if (formulabar) {
        this.fbarExpanded = true;
        formulabar.click();
      }
    } else {
      if (this.nzTreeComponent) {
        const node: NzTreeNode =
          this.nzTreeComponent.getTreeNodeByKey("expandFbar");
        this.fbarExpanded = false;
        if (node) {
          node.isExpanded = true;
          this.addChildNode(node);
          this.fbarExpanded = true;
        }
      }
    }
  }

  resetBrokerCount() {
    this.brokerCountForSellSide =
      this.brokerCountForSellSide > 0 ? -1 : this.brokerCountForSellSide;
  }

  getSubFormulaValue(values) {
    if (values.formula && values.formula.opd) return values.formula.opd;
    if (values.formula && !values.formula.opd) return values.formula;
    return values;
  }

  recursiveOpdValues(opdVals) {
    if (opdVals.opd) {
      //Additional check for #CORE-161
      let hasValuationCut = false;
      let hasStdCut = false;
      let hasRefCutForAvgOperator = false;
      for (const val of opdVals.opd) {
        if (!hasStdCut) {
          hasStdCut = val.cut === "STD";
        }
        if (!hasValuationCut) {
          hasValuationCut = this.valuationCuts.includes(val.cut);
        }
        hasRefCutForAvgOperator = opdVals.opr === "avg" && val.cut === "REF";
        if (val.value !== undefined && val.value !== null) {
          if (
            hasValuationCut ||
            (hasStdCut &&
              this.formulabarData.period &&
              this.formulabarData.period.startsWith("CY")) ||
            (val.name !== "CONST" && !this.opdDpIds.has(val.dp)) ||
            (hasRefCutForAvgOperator && val.type === "CONST")
          ) {
            this.opdVals.push(val);
            // if numerator and denominator has same value then it should be shown once and not twice while expanding chlild level formula
            this.opdDpIds.add(val.dp);
          }
        } else {
          this.recursiveOpdValues(val);
        }
      }
    }
    return this.opdVals;
  }

  setDetailsRequiredForLog(data) {
    this.ticker = data.ticker;
    this.cut = data.cut;
    this.source = data.source;
    this.actionSource = "FORMULA_BAR_CLICK";
    this.extras = `${data.source}|${data.dp}`;
  }

  setExtraListForLog(data) {
    if (data.source && data.dp) this.extras.push(`${data.source}|${data.dp}`);
  }

  // reset child level data while adding new child node
  resetChildLevelData() {
    this.extras = "";
    this.fbarActionLogged = false;
    this.opdVals = [];
    this.opdDpIds.clear();
    this.sarWithOperand = false;
    this.isInferred = false;
    // this.brokerCountForSellSide = -1;
  }
  logNewFbAction(event) {
    if (event.node.level === 0) {
      // first node toggle
      this.logFbarAction(
        {},
        this.ticker,
        this.cut,
        event.isExpanded ? "FORMULA_BAR_EXPANDED" : "FORMULA_BAR_CLOSED",
        this.source,
        this.actionSource,
        this.extras,
      );
    }
  }

  logFbarAction(
    event,
    ticker,
    cut,
    feature,
    source,
    actionSource,
    extras = "",
  ) {
    this.appService.logUserAction(
      {},
      ticker,
      cut,
      feature,
      extras,
      source,
      actionSource,
    );
  }

  generateExpression(data) {
    if (
      data.opr &&
      (data.opr.toLowerCase() === "avg" ||
        data.opr.toLowerCase() === "mode" ||
        data.opr.toLowerCase() === "restated")
    ) {
      return;
    }

    if (data.value === undefined) {
      let ignoreZero = false;
      if (data.opd && data.opd.length > 0 && data.opd[0].opd) {
        this.expressionList.push({ value: "(" });
        const notEntitledValues = data.opd[0].opd.filter(
          (item) => item.param_id === "not entitled",
        );
        ignoreZero = true;
        this.generateExpression(data.opd[0]);
        const nonentitledBrokerCount = this.brokerCountForSellSide;
        // +1 because this.brokerCountForSellSide is initialized to -1
        if (
          nonentitledBrokerCount + 1 > 0 &&
          nonentitledBrokerCount + 1 === 1 &&
          notEntitledValues > 0
        ) {
          this.expressionList.push({
            value:
              this.expressionList.length > 1
                ? `and ${nonentitledBrokerCount + 1} other `
                : ` ${nonentitledBrokerCount + 1} source `,
          });
        } else if (nonentitledBrokerCount + 1 > 1 && notEntitledValues > 0) {
          this.expressionList.push({
            value:
              this.expressionList.length > 1
                ? `and ${nonentitledBrokerCount + 1} others `
                : ` ${nonentitledBrokerCount + 1} sources `,
          });
        }
        this.expressionList.push({ value: ")" });
      }

      const d = data["opr"];
      let Oitr = 0;
      const opdVals = [...data.opd];
      const opdLength = opdVals.length;
      const constExist = opdVals.find((obj) => {
        return obj.name === "CONST" && Number.isInteger(obj.value);
      });
      for (const val of opdVals) {
        if (val.opd === undefined && val.value === undefined) {
          //keeping it as of now will remove later
          this.expressionList.push({ value: "(" });
          this.generateExpression(val);
          this.expressionList.push({ value: ")" });
        }

        if (val.opd && !ignoreZero) {
          if (this.expressionList.length > 0) {
            const peek = this.expressionList[this.expressionList.length - 1];
            if (!peek.value || (peek.value && peek.value !== d)) {
              //Add expression only if not previously added.
              this.expressionList.push({ value: d });
            }
          } else {
            this.expressionList.push({ value: d });
          }
          this.expressionList.push({ value: "(" });
          this.generateExpression(val);
          this.expressionList.push({ value: ")" });
        }
        ignoreZero = false;

        if (val.value !== undefined) {
          Oitr++;
          // should add operator(*,/,+,-) when previous value is target price, data.opd && data.opd.length > 0 && data.opd[0].cut === "REF" && data.opd[0].dp === "REF_13"
          if (
            (constExist &&
              data.opd &&
              data.opd.length > 1 &&
              data.opd[1].name !== "CONST" &&
              data.opd[0].name !== "CONST") ||
            (data.opd && data.opd.length > 0 && data.opd[0].opr) ||
            ((this.valuationCuts.includes(val.cut) ||
              (val.cut === "STD" &&
                this.formulabarData &&
                this.formulabarData.dp &&
                typeof this.formulabarData.dp === "string" &&
                this.formulabarData.dp.includes("SCALCR"))) &&
              this.expressionList.length > 0 &&
              (this.expressionList[this.expressionList.length - 1].cut ||
                this.expressionList[this.expressionList.length - 1].value ===
                  ")")) ||
            (data.opd &&
              data.opd.length > 0 &&
              data.opd[0].cut === "REF" &&
              this.targetPriceDp.includes(data.opd[0].dp))
          ) {
            let addOpr = false;
            if (
              Oitr <= opdLength &&
              this.expressionList.length > 2 &&
              this.expressionList[this.expressionList.length - 1].value &&
              this.expressionList[this.expressionList.length - 1].value === ")"
            ) {
              addOpr = true;
            }
            addOpr || (Oitr <= opdLength && Oitr > 1)
              ? this.expressionList.push({ value: d })
              : "";
            this.expressionList.push(this.getRequiredValues(val));
          } else {
            // object with type CONST doesn't have param_id
            // @todo ideally in response we should never get value if param_id === 'not entitled' if that happens entire block can be handled by val !== undefined
            if (
              (val.param_id && val.param_id !== "not entitled") ||
              (!val.param_id && val.type === "CONST")
            ) {
              this.expressionList.push(this.getRequiredValues(val));
              Oitr !== opdLength ? this.expressionList.push({ value: d }) : "";
            } else {
              this.brokerCountForSellSide++;
            }
          }
        }
      }
      // if (data.opd.length > 1 && data.opd[1].opd) {
      //   if (data.opd.length > 2) {
      //     for (const val of data.opd.slice(1)) {
      //       if (val.opd && val.opr) {
      //         if (this.expressionList.length > 0) {
      //           const peek = this.expressionList[
      //             this.expressionList.length - 1
      //           ];
      //           if (!peek.value || (peek.value && peek.value !== d)) {
      //             //Add expression only if not previously added. CACC-4375
      //             this.expressionList.push({ value: d });
      //           }
      //         } else {
      //           this.expressionList.push({ value: d });
      //         }
      //         this.expressionList.push({ value: "(" });
      //         this.generateExpression(val);
      //         this.expressionList.push({ value: ")" });
      //       }
      //     }
      //   } else {
      //     data.opd[1].opr && data.opd[0].opr
      //       ? this.expressionList.push({ value: data.opr })
      //       : "";
      //     this.expressionList.push({ value: "(" });
      //     this.generateExpression(data.opd[1]);
      //     this.expressionList.push({ value: ")" });
      //   }
      // }
    } else {
      this.expressionList.push(this.getRequiredValues(data));
    }
  }

  getRequiredValues(data) {
    return {
      cut: data.cut,
      name: data.type === "CONST" && !data.exchange_info ? "CONST" : data.name,
      period: data.period,
      precision: data.precision,
      source: data.source,
      unit: data.unit,
      value: data.value,
      brokerCount: this.brokerCountForSellSide,
      exchange_info: data.exchange_info,
      isConst: data.type === "CONST",
      formatedValue: Number(data.value).toFixed(2),
    };
  }

  //return text need to be shown on hover of expression detail
  getPopOverText(nodeObj) {
    let text = nodeObj.name;
    if (nodeObj.display_magnitude) {
      text += `(${this.formulabarData.display_magnitude})`;
    }
    if (nodeObj.source) {
      text += "[";
      text += `${nodeObj.source}`;
      if (nodeObj.period) {
        text += ` ,${nodeObj.period}`;
      }
      if (nodeObj.modeldate) {
        text += ` ,${nodeObj.modeldate}`;
      }
      if (nodeObj.analyst && nodeObj.analyst.length > 0) {
        text += ` ,${nodeObj.analyst}`;
      }
      text += "]";
    }
    return text;
  }
}
